import React from 'react';
import { Link } from 'react-router-dom';
import './CTAButton.css';

const CTAButton = ({ 
  children, 
  variant = 'primary', 
  onClick, 
  className = '', 
  type = 'button',
  href 
}) => {
  const buttonClass = `cta-button ${variant} ${className}`.trim();
  
  if (href) {
    return (
      <Link to={href} className={buttonClass}>
        {children}
      </Link>
    );
  }
  
  return (
    <button 
      type={type} 
      className={buttonClass} 
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default CTAButton;
